import * as c from "./constants";
import { combineReducers } from "redux";

const cartState = {
  id: "",
  cards: [],
};

function cart(state = cartState, action) {
  switch (action.type) {
    case c.SET_CART_ID:
      return { ...state, id: action.payload };
    case c.SET_CART_CARDS:
      return { ...state, cards: action.payload };
    case c.RESET_CART: {
      return cartState;
    }
    default:
      return state;
  }
}

function loading(
  state = {
    state: {},
  },
  action
) {
  switch (action.type) {
    case c.SET_LOADING_STATE:
      return {
        ...state,
        state: Object.assign({}, state.state, {
          [action.payload.id]: action.payload.state,
        }),
      };

    default:
      return state;
  }
}

function error(
  state = {
    update: "",
    add: {},
  },
  action
) {
  switch (action.type) {
    case c.SET_ADD_CARD_ERROR:
      return {
        ...state,
        add: Object.assign({}, state.add, {
          [action.payload.id]: action.payload.msg,
        }),
      };

    case c.SET_UPDATE_CARD_ERROR:
      return { ...state, update: action.payload };

    default:
      return state;
  }
}

export default combineReducers({ cart, error, loading });
